// Custom
import './index.scss';

import Plyr from 'plyr';

import Splide from '@splidejs/splide'
import Lottie from 'lottie-web';

import * as realisations from './js/realisations.js'
import * as savoirfaire from './js/savoirfaire.js'
import * as reveal from './js/reveal.js'
//import anime from 'animejs/lib/anime.es.js';


//import SwupJsPlugin from '@swup/js-plugin';
import Swup from "swup";
// import SwupSlideTheme from '@swup/slide-theme';
import SwupScrollPlugin from '@swup/scroll-plugin';
// import SwupGaPlugin from '@swup/ga-plugin';
// import SwupBodyClassPlugin from '@swup/body-class-plugin';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);


let logo = null
let  logoAccroche = null


document.addEventListener("DOMContentLoaded", function (event) { //
    init()


});



const swup = new Swup({
    ignoreVisit: (url, { el } = {  }) => testUrlSwup(url), 
    plugins: [
        // new SwupScrollPlugin({
        //     betweenPages: true,
        //     samePageWithHash: true,
        //     samePage: true
        // }),
    ]
});


const testUrlSwup = (url) => {

    if (url.includes('/contact') ) return true;   
    return false;
  }


swup.hooks.on('content:replace', function () {
    init()
});



swup.hooks.before('content:replace', function () {

    if (document.querySelector('.video__masque')) {
        document.querySelectorAll('.video__masque').forEach(element => {
            element.classList.remove('anim')
        });
    }
    document.querySelector('body').classList.remove('menu-active')
    document.querySelector('.menu__complet').classList.remove('menu__complet--reduit')
    
    savoirfaire.unmount()


    if (document.querySelector('.video__zone__slider')) {
        const zonesSlider = document.querySelector('.container__blocs-realisations')

        zonesSlider.querySelectorAll('.realisation__detail').forEach((splide, index) => {
                splide.removeEventListener("mouseover", function (e) {
                    playersSliders[index].play()
                })
                splide.removeEventListener("mouseout", function (e) {
                    playersSliders[index].pause()
                })
        });
    }


})



const init = function () {

    setNav()

    document.getElementById('logo__anim').innerHTML = ''
    logo = Lottie.loadAnimation({
        container: document.getElementById('logo__anim'), // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        name: 'logo',
        path: '/wp-content/themes/kashmir-prod/animation/logo-loop.json' // the path to the animation json
      });
      Lottie.pause()
    

    if ( document.querySelector('.accroche__logo')) {
        logoAccroche = Lottie.loadAnimation({
            container: document.querySelector('.accroche__logo'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            name: 'logo-accroche',
            path: '/wp-content/themes/kashmir-prod/animation/logo.json' // the path to the animation json
          });
         
    }


    // if (document.querySelector('.titre_slide') ) {

    //     const texteSlides = document.querySelectorAll('.titre_slide');

    //     texteSlides.forEach(element => {
    //         var textWrapper = element;
    //             textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

    //             anime.timeline({loop: true})
    //             .add({
    //                 targets: '.titre_m .letter',
    //                 //translateX: [40,0],
    //                 translateZ: 0,
    //                 opacity: [0,1],
    //                 easing: "easeOutExpo",
    //                 duration: 2200,
    //                 delay: (el, i) => 500 + 30 * i
    //             }).add({
    //                 targets: '.titre_m .letter',
    //                 //translateX: [0,-30],
    //                 opacity: [1,0],
    //                 easing: "easeInExpo",
    //                 duration: 1100,
    //                 delay: (el, i) => 100 + 30 * i
    //             });

    //     });
    // }
    


    // Init reveal
    reveal.init()

    // Init apparition vidéos
    const videoMasques = document.querySelectorAll('.video__masque');
    videoMasques.forEach((section, index) => {
        if ( !section.classList.contains('video__masque__header')) {
          
            ScrollTrigger.create({
                trigger: section,
                id: index + 1,
                start: 'top 70%',
                end: 'bottom 70%',
                onEnter: () => {
                   section.classList.add('anim')
                },
                onLeave: () => {
                    self => self.disable()
                },
                onLeaveBack: self => self.disable(),
                markers: false // !! MARQUERUS
            })
        }
    })

    

    if ( document.querySelector('.section__header__realisations')) realisations.initRealisation()
    else if ( document.querySelector('.section__header')) realisations.initSection()


    if (document.querySelector(".video-play")) {
        const videos = document.querySelectorAll('.video-play')

        videos.forEach(video => {
            if (document.querySelector('body').classList.contains('mobile')) video.play();
            else {
                video.closest(".section__bloc-video").addEventListener("mouseover", function (e) {
                    video.play();
                })
                video.closest(".section__bloc-video").addEventListener("mouseout", function (e) {
                    video.pause();
                })
            }
        });
    }


    


    if (document.querySelector('.section__savoirfaire')) {
        savoirfaire.init()
    }

    const menuConteneur = document.querySelector('.menu__complet');
    const menuLogo = menuConteneur.querySelector('.logo');

    // Affichage menu réduit
    ScrollTrigger.create({
        trigger: menuConteneur,
        id: 1,
        start: 'top ',
        end: 'top 30%',
        onEnter: () => {
            menuConteneur.classList.add('menu__complet--reduit')
        },
        onLeave: () => {
            //self => self.disable()
        },
        onLeaveBack: () => {
            menuConteneur.classList.remove('menu__complet--reduit')
            document.querySelector('body').classList.remove('menu-active')
        },
        markers: false
    })


    // if (document.querySelector('.section__banniere')) {
    //     const banner = document.querySelector('.section__banniere');
    //     ScrollTrigger.create({
    //         trigger: document.querySelector('#banner__trigger'),
    //         id: 1,
    //         start: 'bottom 65%',
    //         end: 'bottom 85%',
    //         //end: () => `+=${document.querySelector(".section__banniere").offsetHeight}`,
    //         onEnter: () => {
    //             console.log('quit')
    //             banner.classList.add('is-active')
    //         },
    //         onLeave: () => {
    //             //self => self.disable()
    //         },
    //         onLeaveBack: () => {
    //             console.log('back')
    //             banner.classList.remove('is-active')
    //         },
    //         markers: false
    //     })
    // }


    // if (document.querySelector('.contact__photo')) {

    //     ScrollTrigger.create({
    //         trigger: document.querySelector('.contact__photo'),
    //         id: 1,
    //         start: 'top +50%',
    //         end: "bottom",
    //         //end: () => `+=${document.querySelector(".section__banniere").offsetHeight}`,
    //         onEnter: () => {
    //             console.log('quit')
    //             document.querySelector('.contact__photo').classList.add('is-active')
    //         },
    //         onLeave: () => {
    //             //self => self.disable()
    //         },
    //         onLeaveBack: () => {
    //             console.log('back')
    //             document.querySelector('.contact__photo').classList.remove('is-active')
    //         },
    //         markers: false
    //     })
    // }





    if (document.querySelector('.hero-body')) {
        setTimeout(() => {
            document.querySelector('.hero-body').classList.add('is-active')
        }, 1500);

        setTimeout(() => {
            document.querySelector('.hero-body').classList.add('is-complete')
        }, 3000);
    }


    if (document.querySelector('.titre_anim')) {
        setTimeout(() => {
            document.querySelector('.titre_anim').classList.add('is-active')
        }, 500);

    }

    if (document.querySelector('.video__masque__header')) {
     
        const masques = document.querySelectorAll('.video__masque__header')
        var temps = 1200
        masques.forEach(element => {
            setTimeout(() => {
                element.classList.add('anim')
            }, temps);
            temps += 200
        });
    }


    if (document.querySelector('.section__header__realisations')) {
        setTimeout(() => {
            var realisations = document.querySelectorAll('.section__header__realisations')
            realisations.forEach(element => {
                element.classList.add('is-active')
            });
        }, 500);
    }



    if (document.querySelector('.trailler__vignette')) {
        const playTrailler = document.querySelector('.trailler__vignette')
        playTrailler.addEventListener("click", function (e) {
            document.querySelector('.trailler__conteneur').classList.add('is-active')
            player.play();
        })
    }


        // Slide accroches
        if (document.querySelector('.splide__accroches')) {
            var splideAccroches = new Splide('.splide__accroches', {
                type: 'loop',
                drag: true,
                focus: 'center',
                perPage: 1,
                autoPlay: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                arrows :'false' ,
                interval: 1000,
                
            })

            splideAccroches.on( 'autoplay:playing', function ( rate ) {
                console.log( rate ); // 0-1
              } );


            splideAccroches.on( 'ready', function () {
                // do something
                console.log('ok')
              } );

              splideAccroches.on( 'move', function () {
                // do something
                console.log('move')
              } );

              splideAccroches.mount();
        }

    // vidéos sliders
    const playersSliders = Plyr.setup('.video__zone__slider', {
        youtube: { noCookie: true, start: 1, muted:true },
        quality: 1080,
        muted:true 
    });
 
    // Slide vidéos
    // if (document.querySelector('.splide__realisations')) {
    //     const splide = new Splide('.splide__realisations', {
    //         //  type: 'loop',
    //         drag: 'free',
    //         focus: 'center',
    //         perPage: 4,
    //         breakpoints: {
    //             1200: {
    //                 perPage: 4,
    //             },
    //             1024: {
    //                 perPage: 3,
    //             },
    //             640: {
    //                 destroy: true,
    //             },
    //         },
    //         autoScroll: {
    //             speed: 2,
    //         },
    //     });
    //     splide.mount();


       
    // }

    if (document.querySelector('.video__zone__slider')) {
        const zonesSlider = document.querySelector('.container__blocs-realisations')

        zonesSlider.querySelectorAll('.realisation__detail').forEach((splide, index) => {
            console.log('video',index)
                splide.addEventListener("mouseover", function (e) {
                    playersSliders[index].play()
                    console.log('hover')
                })
                splide.addEventListener("mouseout", function (e) {
                    playersSliders[index].pause()
                })
        });
    }

}


const menuBouton = document.querySelector('.menu__bouton')
menuBouton.addEventListener("click", function (e) {
    document.querySelector('body').classList.toggle('menu-active')
})



const setNav = () => {
    let url = window.location.pathname.split('/')
    const menu = document.querySelectorAll('.menu-item')
    menu.forEach(element => {
        element.classList.remove('current-menu-item')
        var href = element.querySelector('a').href.split('/')
        if (url[1] == href[3]) {
            element.classList.add('current-menu-item')
        }
    });
}


